import React from 'react';
import styled from '@emotion/styled';
import { useLocale } from 'locale';
import PromoteIcon from 'assets/svg/private-bulletin-promotion/promote-icon.svg';
import { useCountdown, formatCountdown } from 'hooks/useCountdown';
import { BasicButtonProps } from 'ds/components/button/BasicButton';
import { CustomButton } from '../CustomButton';

const StyledButton = styled(CustomButton)<{ isTimeLeft: boolean }>(({ theme, isTimeLeft }) => ({
  ...isTimeLeft ? {
    background: '#F4F4F4',
    color: theme.colors.brand.main,
    '> svg path': {
      stroke: '#606060',
    },
  } : null,
}));

// Prevent countdown text jump around because of different digits width.
const CountdownSpan = styled.span(() => ({
  display: 'inline-block',
  minWidth: 58,
  textAlign: 'left',
}));

export interface ManualPromoteBulletinButtonProps {
  promotedUntil: Date;
  onClick: (event: React.MouseEvent, data: { timeLeft: number }) => void;
  mode?: BasicButtonProps['mode'];
  size?: BasicButtonProps['size'];
  className?: string;
  disabled?: boolean;
  fullWidth?: boolean;
}

export const ManualPromoteBulletinButton = React.forwardRef<any, ManualPromoteBulletinButtonProps>((props, ref) => {
  const { promotedUntil, onClick, mode = 'primary', size, className, disabled, fullWidth } = props;
  const { t } = useLocale();
  const timeLeft = useCountdown(promotedUntil);
  const isTimeLeft = timeLeft > 0;

  const handleClick = (event: React.MouseEvent) => {
    onClick(event, { timeLeft });
  };

  return (
    <StyledButton
      ref={ref}
      onClick={handleClick}
      className={className}
      size={size}
      mode={isTimeLeft ? 'ghost' : mode}
      isTimeLeft={isTimeLeft}
      disabled={disabled}
      fullWidth={fullWidth}
    >
      <PromoteIcon mode={mode} height={isTimeLeft ? 18 : 21} />
      {isTimeLeft ? (
        <CountdownSpan>{formatCountdown(timeLeft)}</CountdownSpan>
      ) : t('privateBulletinPromotion.manualPromoteButton')}
    </StyledButton>
  );
});
